<template>
  <div class="subModal">
    <form @submit.prevent="setPass">
      <input type="password" name="current" placeholder="Senha atual" v-model="current">
      <input type="password" name="pass" placeholder="Nova senha" v-model="pass">
      <input type="password" name="passr" placeholder="Repita a nova senha" v-model="passr">
      <button>Confirmar</button>
    </form>
  </div>
</template>

<script setup>


import { ref } from 'vue'

const emits = defineEmits(['textAlerta'])

const current = ref('')
const pass = ref('')
const passr = ref('')

async function setPass() {
  if (!current.value) {
    emits('textAlerta', 'Informe a senha atual')
    return
  }
  if (pass.value !== passr.value) {
    emits('textAlerta', 'Senhas não coincidem')
    return
  }
  try {
    const res = await fetch('/api/account', {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ current_password: current.value, new_password: pass.value }),
    })
    const data = await res.json()
    emits('textAlerta', data.message ?? 'Senha alterada!')
    if (res.ok && data.success) {
      current.value = ''
      pass.value = ''
      passr.value = ''
    }
  } catch (_) {
    emits('textAlerta', 'Erro ao alterar senha')
  }
}

</script>

<style scoped>

</style>
